import { useState, useEffect } from "react";
import {
  ConfigProvider,
  Space,
  Table,
  Form,
  Tag,
  Input,
  Flex,
  InputNumber,
  Button,
  Modal,
  message,
} from "antd";
const { TextArea } = Input;
import { useForm, Controller } from "react-hook-form";

import { ColumnTransaksiSekre } from "../../../library/FormColumn";
import { ICONS } from "@/assets";

import data from "./data";

const SekretarisPage = () => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);

  const [confirmLoading, setConfirmLoading] = useState(false);
  const [textModal, setTextModal] = useState("Ini konten modal awal");
  const [initialValues, setInitialValues] = useState({
    tgl: "",
    noAcc: "",
    nameAcc: "",
    keterangan: "",
    // debet: "",
    // kredit: "",
    // saldo: "",
    kode: "",
    kolom: "",
  });

  const openModal = () => {
    setOpen(true);
  };

  const openModalEdit = () => {
    setInitialValues((value) => ({
      ...value,
      noAcc: "111",
    }));

    setModalEdit(true);
  };

  const handleClose = () => {
    console.log("close modal");
    setOpen(false);
    setModalEdit(false);
    reset();
    // form.resetFields();
  };

  // Hook Form
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ defaultValues: initialValues });

  console.log(initialValues);

  const onSumbit = async (data) => {
    try {
      console.log("Data yg di input = ", data);

      setConfirmLoading(true);
      setTimeout(() => {
        setOpen(false);
        setConfirmLoading(false);
        message.success("Berhasil tambah data");
        reset();
      }, 2000);
    } catch (error) {
      console.error(error);
      message.error("Proses Tambah Data Gagal!");
    }
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      console.log("ini value yg di input >", values);

      setConfirmLoading(true);
      setTimeout(() => {
        setOpen(false);
        setConfirmLoading(false);
        form.resetFields();
        message.success("Berhasil tambah data");
      }, 2000);
    } catch (error) {
      message.error("Gagal tambah data");
    }
    // setTextModal("download ing on 2 seconds");
  };

  const actionColumn = {
    title: "Action",
    key: "action",
    render: (_, record) => (
      <Space size="middle">
        <button onClick={() => handleModal("view", record)}>
          <img src={ICONS.FaDetail} alt="View" />
        </button>

        <button onClick={() => handleModal("edit", record)}>
          <img src={ICONS.FaEdit} alt="Edit" />
        </button>

        <button onClick={() => handleModal("delete", record)}>
          <img src={ICONS.FaTrash} alt="Delete" />
        </button>
      </Space>
    ),
  };
  const extendedColumn = [...ColumnTransaksiSekre.columns, actionColumn];

  // console.log(form);

  const contentModal = () => {
    return (
      <>
        <form className="flex flex-col gap-2">
          <div>
            <label>No. Akun</label>
            <Controller
              name="noAcc"
              control={control}
              rules={{ required: "Nomor akun harus diisi!" }}
              render={({ field }) => (
                <Input {...field} placeholder="Nomor akun anda" size="large" />
              )}
            />
            {errors.noAcc && (
              <span className="text-red-500">{errors.noAcc.message}</span>
            )}
          </div>

          <div>
            <label>Nama Akun</label>
            <Controller
              name="nameAcc"
              control={control}
              rules={{ required: "Nama akun harus diisi!" }}
              render={({ field }) => (
                <Input {...field} placeholder="Nama akun anda" size="large" />
              )}
            />
            {errors.nameAcc && (
              <span className="text-red-500">{errors.nameAcc.message}</span>
            )}
          </div>

          <div className="flex gap-4">
            <div>
              <label htmlFor="kode">Kode</label>
              <br />
              <Controller
                name="kode"
                control={control}
                rules={{ required: "Kode harus diisi!" }}
                render={({ field }) => (
                  <InputNumber
                    {...field}
                    placeholder="Kode Bank"
                    size="large"
                    className="w-full"
                  />
                )}
              />
              {errors.kode && (
                <p className="text-red-500">{errors.kode.message}</p>
              )}
            </div>
            <div>
              <label htmlFor="kolom">Kolom</label>
              <br />
              <Controller
                name="kolom"
                control={control}
                rules={{ required: "Kolom harus diisi!" }}
                render={({ field }) => (
                  <InputNumber
                    {...field}
                    placeholder="kolom Bank"
                    size="large"
                    className="w-full"
                  />
                )}
              />
              {errors.kolom && (
                <p className="text-red-500">{errors.kolom.message}</p>
              )}
            </div>
          </div>

          <div>
            <label>Keterangan</label>
            <Controller
              name="keterangan"
              control={control}
              // rules={{
              //   required: "Min. 5 karakter",
              //   minLength: {
              //     value: 5,
              //     message: "keterangan harus minimal 5 karakter",
              //   },
              // }}
              render={({ field }) => (
                <TextArea
                  {...field}
                  placeholder="Keterangan akun"
                  size="large"
                  rows={3}
                />
              )}
            />
            {errors.keterangan && (
              <span className="text-red-500">{errors.keterangan.message}</span>
            )}
          </div>
        </form>
        {/* <Form form={form} initialValues={initialValues} layout="vertical">
          <Form.Item label="No. Akun" name={"noAcc"}>
            <Input size="large" />
          </Form.Item>

          <Form.Item
            label="Nama"
            name="name"
            rules={[{ required: true, message: "Nama harus diisi!" }]}
            className="mb-3"
          >
            <Input placeholder="Masukkan nama" size="large" />
          </Form.Item>

          <Form.Item
            label="Deskripsi"
            name="description"
            rules={[{ required: true, message: "Deskripsi harus diisi!" }]}
          >
            <Input.TextArea placeholder="Masukkan deskripsi" />
          </Form.Item>
        </Form> */}
      </>
    );
  };

  return (
    <div>
      <h1 className="text-4xl font-semibold mb-8">Sekretaris Page</h1>

      <div className="flex justify-between">
        <Button
          type="primary"
          size="large"
          onClick={openModal}
          className=" bg-primary text-white py-2 px-4 rounded-md mb-4"
        >
          Tambah Data
        </Button>

        <Button
          type="primary"
          size="large"
          onClick={openModalEdit}
          className=" bg-primary text-white py-2 px-4 rounded-md mb-4"
        >
          Edit Data
        </Button>

        <div className="flex gap-4">
          <Button
            size="large"
            // type="primary"
            className=" bg-red-500 text-white py-2 px-4 rounded-md mb-4"
          >
            Export PDF
          </Button>
        </div>
      </div>

      <ConfigProvider
        theme={{
          components: {
            Table: {
              colorPrimary: "#0164A2",
              headerColor: "#fff",
              headerBg: "#0164A2",
              headerBorderRadius: 6,
              algorithm: true,
              // borderColor: "#000",
            },
            Pagination: {
              colorPrimary: "#0164A2",
              colorPrimaryHover: "#0164A2",
              colorPrimaryBorder: "#0164A2",
              algorithm: true,
            },
          },
        }}
      >
        <Table columns={extendedColumn} dataSource={data} size="middle" />
      </ConfigProvider>

      {/* modal */}
      <Modal
        title="Tambah Trx"
        open={open}
        onOk={handleSubmit(onSumbit)}
        confirmLoading={confirmLoading}
        onCancel={handleClose}
        // okText={}
        // cancelText={}
      >
        {contentModal()}
      </Modal>

      <Modal
        title="Edit Trx"
        open={modalEdit}
        onOk={handleSubmit(onSumbit)}
        confirmLoading={confirmLoading}
        onCancel={handleClose}
        // okText={}
        // cancelText={}
      >
        {contentModal()}
      </Modal>
    </div>
  );
};

export default SekretarisPage;
